import script from "./rich-text-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./rich-text-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__